import { useEffect, useState } from 'react'
import DateHelper from '../../../utils/DateHelper'
import { TenantService } from '@propertelligent/client-api'
import apiHelper from '../../../utils/apiHelper'

const CurrentAddressInfo = ({ CurrentAddress }) => {
  const [moveOutReason, setMoveOutReason] = useState([])

  const getMoveOutReason = () => {
    apiHelper(TenantService.getApiTenantMoveMoveReasonTypes, { showNotification: false })
      .then((res) => {
        setMoveOutReason(res?.data?.success)
      }).catch((err) => { })
  }

  const getNameByValue = (moveOutReasons: { id: number; name: string }[], value: number): string | undefined => {
    return moveOutReasons.find(reason => reason.id === value)?.name;
  }

  useEffect(() => {
    getMoveOutReason()
  }, [])

  return (
    <>
      <div className="current_address">
        {/* <div className="current_address_Fdetail">
          <p className="normal_text black">
            {[
              CurrentAddress?.unitNumber,
              CurrentAddress?.streetAddress,
              CurrentAddress?.city,
              CurrentAddress?.state,
              CurrentAddress?.zip,
            ]
              .filter(Boolean) 
              .join(", ")}
          </p>
        </div> */}
        <div className="current_address_Sdetail ">
          {["Address", "Move out date", "Reason to move" ].map((label, idx) => (
            <div key={idx} className="current_address_Sdetail_boxx addressItem ">
             
              <p className="normal_text fw-bold black">
                {idx === 0 ? [
              CurrentAddress?.unitNumber,
              CurrentAddress?.streetAddress,
              CurrentAddress?.city,
              CurrentAddress?.state,
              CurrentAddress?.zip,
            ]
              .filter(Boolean) 
              .join(", ")  :idx === 1 ? DateHelper.convertUTCtoDateTime2(CurrentAddress?.moveOutDate)
                  : typeof (CurrentAddress?.moveOutReasonTypeId) ?
                    getNameByValue(moveOutReason, CurrentAddress?.moveOutReasonTypeId)
                    : CurrentAddress?.moveOutReasonTypeId
                }
              </p>
               <p className="normal_text  black">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default CurrentAddressInfo